import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TickerSearch = () => {
    const [ticker, setTicker] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (ticker.trim()) {
            // Navigate to the ticker dashboard with the symbol
            navigate(`/stockAnalysis/${ticker.trim().toUpperCase()}`);
        }
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-6 max-w-md mx-auto">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Search Ticker</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="ticker" className="block text-sm font-medium text-gray-700 mb-2">
                        Enter Stock Symbol
                    </label>
                    <input
                        type="text"
                        id="ticker"
                        value={ticker}
                        onChange={(e) => setTicker(e.target.value.toUpperCase())}
                        placeholder="e.g., AAPL, TSLA, SMCI"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                    View Ticker Analysis
                </button>
            </form>
            
            {/* Quick access buttons */}
            <div className="mt-6">
                <p className="text-sm text-gray-600 mb-3">Quick access:</p>
                <div className="flex space-x-2">
                    {['AAPL', 'TSLA', 'SMCI', 'GOOGL', 'MSFT'].map((quickTicker) => (
                        <button
                            key={quickTicker}
                            onClick={() => navigate(`/stockAnalysis/${quickTicker.trim().toUpperCase()}`)}
                            className="flex-1 bg-gray-100 text-gray-700 py-2 px-3 rounded-md text-sm hover:bg-gray-200 transition-colors"
                        >
                            {quickTicker}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TickerSearch;